import { Link } from "react-router-dom";

export const QualityAndAcademicIntegrityConst = {
  path: "/single-page/quality-and-academic-integrity",
  title: "КАЧЕСТВО И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ",
  contentJSX: (
    <>
      <h2>КАЧЕСТВО ОБРАЗОВАНИЯ И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн</p>
      <p>Язык: русский / английский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. СИСТЕМЫ ОБЕСПЕЧЕНИЯ КАЧЕСТВА (QA) — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>ENQA и ESG: европейские стандарты – 12 ч</li>
        <li>Национальные подходы к аккредитации – 12 ч</li>
        <li>Внутреннее качество и самооценка – 12 ч</li>
      </ul>
      <h2>II. АКАДЕМИЧЕСКАЯ ЭТИКА И АНТИПЛАГИАТ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Принципы академической честности – 6 ч</li>
        <li>Использование антиплагиатных систем – 6 ч</li>
        <li>Разработка политики академической добросовестности – 6 ч</li>
        <li>Этические кейсы и конфликтные ситуации – 6 ч</li>
        <li>Обучение студентов этике – 6 ч</li>
      </ul>
      <h2>III. АККРЕДИТАЦИЯ ПРОГРАММ И АУДИТ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Стандарты WFME, IAAR, FIBAA – 12 ч</li>
        <li>Подготовка к аккредитации – 12 ч</li>
        <li>Аудит учебных программ и преподавателей – 12 ч</li>
      </ul>
      <h2>IV. РАЗВИТИЕ ПРЕПОДАВАТЕЛЕЙ И МОНИТОРИНГ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Программы повышения квалификации – 6 ч</li>
        <li>Обратная связь и оценка преподавателей – 6 ч</li>
        <li>KPI и мониторинг качества – 6 ч</li>
        <li>Методические советы и наставничество – 6 ч</li>
        <li>Вовлечение студентов в оценку качества – 6 ч</li>
      </ul>
      <h2>V. ИТОГОВЫЙ ПРОЕКТ: ПЛАН ПОВЫШЕНИЯ КАЧЕСТВА ВУЗА — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Анализ текущей ситуации и проектирование модели QA – 6 ч</li>
        <li>Презентация и получение экспертной оценки – 6 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    КАЧЕСТВО ОБРАЗОВАНИЯ И АКАДЕМИЧЕСКАЯ ДОБРОСОВЕСТНОСТЬ 
    Общий объём: 144 академических часа
    Формат: онлайн / офлайн
    Язык: русский / английский
    Итог: Международный сертификат
    I. СИСТЕМЫ ОБЕСПЕЧЕНИЯ КАЧЕСТВА (QA) — 36 ЧАСОВ
    ENQA и ESG: европейские стандарты – 12 ч
    Национальные подходы к аккредитации – 12 ч
    Внутреннее качество и самооценка – 12 ч
    II. АКАДЕМИЧЕСКАЯ ЭТИКА И АНТИПЛАГИАТ — 30 ЧАСОВ
    Принципы академической честности – 6 ч
    Использование антиплагиатных систем – 6 ч
    Разработка политики академической добросовестности – 6 ч
    Этические кейсы и конфликтные ситуации – 6 ч
    Обучение студентов этике – 6 ч
    III. АККРЕДИТАЦИЯ ПРОГРАММ И АУДИТ — 36 ЧАСОВ
    Стандарты WFME, IAAR, FIBAA – 12 ч
    Подготовка к аккредитации – 12 ч
    Аудит учебных программ и преподавателей – 12 ч
    IV. РАЗВИТИЕ ПРЕПОДАВАТЕЛЕЙ И МОНИТОРИНГ — 30 ЧАСОВ
    Программы повышения квалификации – 6 ч
    Обратная связь и оценка преподавателей – 6 ч
    KPI и мониторинг качества – 6 ч
    Методические советы и наставничество – 6 ч
    Вовлечение студентов в оценку качества – 6 ч
    V. ИТОГОВЫЙ ПРОЕКТ: ПЛАН ПОВЫШЕНИЯ КАЧЕСТВА ВУЗА — 12 ЧАСОВ
    Анализ текущей ситуации и проектирование модели QA – 6 ч
    Презентация и получение экспертной оценки – 6 ч
  `,
};
